import { MyAPSSFormTableItem } from "@/Portfolio/Models/MyNotesInboxTableItem";

class PatientFormAPSS {
    public Id: string;
    public CreationDate: string;
    public FormName: string;
    public APSSId: number;
    public IsPersistant: boolean;
    public PersistanceEndDate: string;
    public EmployeeId: string;
    public EncounterId: string;
    public PatientId: string;
    public HistoricalId: string;
    public Status: string; // Cached
    public LstPrerequis: string; // Cached
    public LastSync: string; // Cached

    // ClientSide var
    public IsLoading: boolean;
    public APssFormDetails: MyAPSSFormTableItem; // Live

    public static GetCachedPrerequis(LstPrerequis: string): APSSPrerequis[] {
        if (!IsNullOrWhiteSpace(LstPrerequis)) {
            try {
                var PreRequis: APSSPrerequis[] = JSON.parse(LstPrerequis);
                return PreRequis;
            }
            catch (ex) {
                console.log("Error loading prerequis for APSS Form", LstPrerequis);
            }
        }

        return null;
    }

    public static GetStatus(Form: PatientFormAPSS): string {
        if (Form.APssFormDetails != null)
            return "- " + Form.APssFormDetails.Model.ReqReg_Etat;
        else if (Form.Status != null)
            return "- " + Form.Status;
        else
            return "";
    }

    public static GetStatusStyle(Form: PatientFormAPSS): React.CSSProperties {
        var latestStatus = "";
        if (Form.APssFormDetails != null)
            latestStatus = Form.APssFormDetails.Model.ReqReg_Etat;
        else
            latestStatus = Form.Status;

        var style: React.CSSProperties = {};

        if (MyAPSSFormTableItem.IsGreen(latestStatus))
            style.color = "#008000";

        if (MyAPSSFormTableItem.IsBold(latestStatus))
            style.fontWeight = "bold";

        if (MyAPSSFormTableItem.IsPurple(latestStatus))
            style.color = "#800080";

        return style;
    }
}

class APSSPrerequis {
    public Name: string;
    public Code: string;
    public IsMissing: boolean;
}

export { PatientFormAPSS };
